import React, {useState} from "react";
import {Link} from "gatsby";
import styled from "@emotion/styled";
import facepaint from 'facepaint'
const mq = facepaint([
    '@media(min-width: 767px)',
    '@media(min-width: 1023px)',
    '@media(min-width: 1439px)'
])



const Navigation = styled('nav')`
  ${mq({
    display:'flex',
    flexDirection: 'column',
    width: ['100%', '60%'],
    marginTop:'0',
    position: ['absolute', 'unset'],
    zIndex:'100',
    top:'130px',
    background: '#171C2F',

    button:{
     position:'absolute',
     top:'-80px',
     right:'8%',
     color:'white',
     background:'transparent',
     border:'none',
     display:['default', 'none']
    },
    
    '& #menu':{
      width:'100%',
      marginTop:'0',
      display:['none', 'flex'],
      flexDirection:['column', 'row'],
      justifyContent:'flex-start',
      alignItems:'center',
      
      '&.active':{
        display:'flex',
        height:[ '100vh', 'inherit'],
      },
      
      li:{
          listStyleType:'none',
          minHeight:'80px',
          width:'100%',
          display:'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent:'center',
          borderTop:['1px solid grey', 'none'],
        
        '&:last-child':{
          borderBottom:['1px solid grey', 'none'] 
        },
        
        a:{
          textDecoration:'none',
          color:'inherit',
          fontSize:'1.5em',
          width: '100%',
          height:'100%',
          display:'flex',
          alignItems:'center',
          justifyContent: 'center',
          
          '&.active':{
            color:'#76E5fA'
          },

            '&:hover':{
              color:'#76E5fA'
            }
        }
      }
    }
})};
`

const Nav = () => {
    const [isToggled, setToggled] = useState(false);
    const toggleTrueFalse = () => setToggled(!isToggled);

    return (
        <Navigation role="navigation">
            <button id="toggle" onClick={toggleTrueFalse} aria-expanded={isToggled} aria-controls="menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="46.701" height="40.863" viewBox="0 0 46.701 40.863">
                    <path id="server" d="M43.782,43.675H2.919A2.919,2.919,0,0,1,0,40.756V34.919A2.919,2.919,0,0,1,2.919,32H43.782A2.919,2.919,0,0,1,46.7,34.919v5.838A2.919,2.919,0,0,1,43.782,43.675ZM39.4,35.649a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,39.4,35.649Zm-5.838,0a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,33.566,35.649ZM43.782,58.269H2.919A2.919,2.919,0,0,1,0,55.35V49.513a2.919,2.919,0,0,1,2.919-2.919H43.782A2.919,2.919,0,0,1,46.7,49.513V55.35A2.919,2.919,0,0,1,43.782,58.269ZM39.4,50.243a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,39.4,50.243Zm-5.838,0a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,33.566,50.243ZM43.782,72.863H2.919A2.919,2.919,0,0,1,0,69.944V64.107a2.919,2.919,0,0,1,2.919-2.919H43.782A2.919,2.919,0,0,1,46.7,64.107v5.838A2.919,2.919,0,0,1,43.782,72.863ZM39.4,64.837a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,39.4,64.837Zm-5.838,0a2.189,2.189,0,1,0,2.189,2.189A2.189,2.189,0,0,0,33.566,64.837Z" transform="translate(0 -32)" fill="#b8b8b9"/>
                </svg>
            </button>
            <ul id="menu" className={isToggled ? 'active' : ' '} aria-expanded="false">
                <li><Link activeClassName='active' to="/blog">Blog</Link></li>
                <li><Link activeClassName='active' to="/contact">Contact</Link></li>
            </ul>
        </Navigation>
    )
}

export default Nav;